import React from "react";
import classNames from "classnames";
import Markdown from "../Markdown";
import { CircledConnectorContainer } from "./styled";
var CircledConnector = function (_a) {
    var comp = _a.comp, className = _a.className, data = _a.data;
    return (React.createElement(CircledConnectorContainer, { className: classNames("circledConnector", className) }, data.map(function (text, index) { return (React.createElement("div", { className: "circledConnector_circledRow", key: text + index },
        React.createElement("span", { className: "circledConnector_circled" }, index + 1),
        React.createElement("div", { className: "circledConnector_circledText" }, text !== "renderCompFromProps" ? React.createElement(Markdown, { source: text }) : comp))); })));
};
CircledConnector.defaultProps = {
    comp: null,
    data: []
};
export default CircledConnector;
